import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import { getValuesFromLocalstorage } from '../../components/Helpers';

const WorkAnniversaryCard = ({ onClose }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [showConfetti, setShowConfetti] = useState(true);
  const [showBalloons, setShowBalloons] = useState(true);
  const empWishes = useSelector((state) => state.EmpWishesReducer);
  const userDetails = getValuesFromLocalstorage('userDetails');

  useEffect(() => {
    // Hide confetti and balloons after 5 seconds
    const timer = setTimeout(() => {
      setShowConfetti(false);
      setShowBalloons(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const handleThankYouClick = () => {
    setIsOpen(false);
    if (onClose) {
      onClose(); // Just close without passing parameter
    }
  };

  // Don't render if not open or no valid anniversary wish
  if (!isOpen || !empWishes?.response?.workAnniversary?.length) {
    return null;
  }

  // Get the first work anniversary wish
  const wish = empWishes.response.workAnniversary[0];

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      transition={{ duration: 0.5 }}
      className="w-full h-full flex flex-col"
    >
      <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 flex-grow flex flex-col">
        <div className="relative bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 p-5 sm:p-6 text-center flex flex-col justify-between flex-grow">
          {/* Animated background elements */}
          <div className="absolute inset-0 overflow-hidden">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="absolute w-1 h-1 rounded-full animate-float"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  backgroundColor: ['#FFD700', '#FF69B4', '#87CEEB', '#98FB98'][Math.floor(Math.random() * 4)],
                  animationDelay: `${Math.random() * 2}s`,
                  animationDuration: `${3 + Math.random() * 2}s`,
                }}
              />
            ))}
          </div>

          <div className="relative z-10 flex flex-col justify-between flex-grow">
            <div>
              <div className="flex justify-center space-x-2 mb-5">
                <div
                  className="text-3xl transform hover:scale-110 transition-transform duration-300 animate-bounce"
                  style={{ animationDelay: '0.2s' }}
                >
                  🎉
                </div>
                <div
                  className="text-3xl transform hover:scale-110 transition-transform duration-300 animate-bounce"
                  style={{ animationDelay: '0.4s' }}
                >
                  🎁
                </div>
                <div
                  className="text-3xl transform hover:scale-110 transition-transform duration-300 animate-bounce"
                  style={{ animationDelay: '0.6s' }}
                >
                  ✨
                </div>
              </div>

              <h2 className="text-xl sm:text-2xl font-bold text-white mb-4 animate-pulse">
                {wish.title}
              </h2>

              <p className="text-sm sm:text-base text-white/90 mb-6 font-light">
                {wish.message}
              </p>
            </div>

            <div className="mt-auto">
              <div className="flex justify-center mb-2">
                <button
                  onClick={handleThankYouClick}
                  aria-label="Send Thank You message and close card"
                  className="bg-white/90 text-indigo-600 px-6 py-3 rounded-lg hover:bg-white transition-all duration-300 transform hover:scale-105 font-semibold text-sm shadow-md backdrop-blur-sm"
                >
                  Thank You!
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default WorkAnniversaryCard;